import React from 'react'
import ReactDOM from 'react-dom'

import './i18n'
import { initDatadog } from './config/datadog'
import { setupFormalizationAPI } from './services/api/formalization-bff/api'
import { mock } from './mock.enable'
import App from './App'

import * as serviceWorker from './serviceWorker'

async function run(): Promise<void> {
  await mock()
  setupFormalizationAPI()
  initDatadog()

  ReactDOM.render(<App />, document.getElementById('root'))

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister()
}

run()
